import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useDispatch } from "react-redux"
import { agregarProgramas } from '../../features/registroProgramasSlice';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ListaProgramas = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const dispatch = useDispatch();
    const [programas, setProgramas] = useState([]);
    const [buscador, setBuscador] = useState('');
    const [expandedId, setExpandedId] = useState(null); // Estado para rastrear el ID de la descripción expandida
    const navigate = useNavigate();
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchProgramas = async () => {
            try {
                let response = await fetch(`${apiUrl}/Programa/Get`,{
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'apiKey': localStorage.getItem("apiKey")
                    }
                });
                if (response.ok) {
                    let data = await response.json();
                    setProgramas(data);
                    dispatch(agregarProgramas(data));
                } else {
                    console.error('Error al obtener programas');
                    manejarErrores(response.status);
                }
            } catch (error) {
                manejarErrores(error);
                console.error('Error en la solicitud', error);
            }
        };
        fetchProgramas();
    }, []);

    const handleBuscadorChange = (event) => {
        setBuscador(event.target.value);
    };

    const handleDelete = async (id) => {
        try {
            let response = await fetch(`${apiUrl}/Programa/${id}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                setProgramas(programas.filter(programa => programa.id !== id));
            } else {
                toast.error("No se pudo borrar el programa, tiene datos asignados", {
                    position: "bottom-center",
                    autoClose: 3000,
                });
                console.error('Error al eliminar el programa');
            }
        } catch (error) {
            console.error('Error en la solicitud', error);
        }
    };

    const toggleExpand = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const manejarErrores = (estatus) => {
        let mensaje = "";
        switch (estatus) {
          case 400:
            mensaje = "Solicitud incorrecta. Verifica los datos enviados.";
            break;
          case 401:
            mensaje = "No autorizado. Por favor inicia sesión.";
            localStorage.clear();
            navigate("/");
            break;
          case 403:
            mensaje = "Acceso denegado. No tienes permiso para acceder a este recurso.";
            navigate("/");
            break;
          case 500:
            mensaje = "Error interno del servidor. Inténtalo de nuevo más tarde.";
            localStorage.clear();
            navigate("/");
            break;
          default:
            mensaje = "Ocurrió un error inesperado.";
            break;
        }
        setError(mensaje);
        toast.error(mensaje, {
            position: "bottom-center",
            autoClose: 3000,
        });
    };

    return (
        <div className="container mt-3">
            <h2 className="mb-3">Lista de Programas</h2>
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por nombre"
                    value={buscador}
                    onChange={handleBuscadorChange}
                />
            </div>

            {/* Contenedor con scroll vertical */}
            <div style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden" }}>
                <table
                    className="table table-striped"
                    style={{ tableLayout: "fixed", width: "100%" }}
                >
                    <thead>
                        <tr>
                            <th style={{ wordWrap: "break-word" }}>Nombre</th>
                            <th style={{ wordWrap: "break-word" }}>Descripción</th>
                            <th>Logo</th>
                            <th style={{ wordWrap: "break-word" }}>CC</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {programas.filter(programa =>
                            programa.nombre.toLowerCase().includes(buscador.toLowerCase())
                        ).map((programa) => (
                            <tr key={programa.id}>
                             
                                <td style={{ wordBreak: "break-word" }}>{programa.nombre}</td>
                                <td style={{ wordBreak: "break-word" }}>
                                    {expandedId === programa.id
                                        ? programa.descripcion
                                        : `${programa.descripcion.substring(0, 50)}...`}
                                    {programa.descripcion.length > 50 && (
                                        <a
                                            className="btn-link"
                                            onClick={() => toggleExpand(programa.id)}
                                        >
                                            {expandedId === programa.id ? 'Ver menos' : 'Ver más'}
                                        </a>
                                    )}
                                </td>
                                <td>
                                    {programa.logo ? (
                                        <img
                                            src={`data:${programa.logoMimeType};base64,${programa.logo}`}
                                            alt="Logo"
                                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                                        />
                                    ) : (
                                        <span>No hay archivo disponible</span>
                                    )}
                                </td>
                                <td style={{ wordBreak: "break-word" }}>{programa.cc}</td>
                                <td>
                                    <IconButton
                                        style={{ color: 'red' }}
                                        onClick={() => handleDelete(programa.id)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <button
                className="btn btnColorPrincipal form-control mt-3"
                onClick={() => navigate("/FormularioPrograma")}
                type="submit"
            >
                Agregar programa
            </button>
        </div>
    );
};

export default ListaProgramas;
